import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionDataService {
  tokenKey = 'g&34%12o';
  userRoleKey = 'userRole';
  userCountryKey='userCountry';
  loginUrlKey = 'loginUrl';
  defaultRedirectUrl='https://in-ova-bi.co/login';
  userPermissions:string[]=[];
  userPermissionPrerfix = 'up__';
  userLanguagePrefix="ul__";
  userServicesPrefix="us__";
  private storage = window.localStorage;

  constructor(){
    
  }

  getItem(key: string) {
    const item=this.storage.getItem(key);
    if(item){
      try {
        return JSON.parse(item);
      } catch (error) {
        return item;
      }
    }
    return null;
  }

  setItem(key: string, data: any) {
      this.storage.setItem(key, JSON.stringify(data));
  }

  removeItem(key: string) {
      this.storage.removeItem(key);
  }

  getToken() {
      const token=this.getItem(this.tokenKey)
      if(token && token.value){
        return token.value;
      }
      return null;
  }

  setToken(value:string) {
    this.setItem(this.tokenKey,{value})
  }

  isLoggedIn(){
    let token=this.getToken();
    if(token && token.length>0) {
      return true;
    }
    return false;
  }

  setUserRole(value:string){
    return this.setItem(this.userRoleKey,value);
  }

  getUserRole(){
    return this.getItem(this.userRoleKey);
  }

  localLogout(redirect=false){
    this.removeItem(this.tokenKey);
    this.removeItemsByPrefix(this.userPermissionPrerfix);
    this.removeItemsByPrefix(this.userServicesPrefix);
    this.removeItemsByPrefix(this.userLanguagePrefix);
    this.userPermissions=[];
    if(redirect && location.href.split('/').pop()!='session-listener'){
      window.location.href=this.getLoginUrl();
    }
  }

  setLoginUrl(loginUrl:string){
    this.setItem(this.loginUrlKey,loginUrl)
  }

  getLoginUrl(){
    const loginUrl=this.getItem(this.loginUrlKey);
    return loginUrl || this.defaultRedirectUrl
  }

  isSafariBrowser(){
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
  }

  setUserPermissions(permissions:string[]){
    this.userPermissions=permissions;
    this.removeItemsByPrefix(this.userPermissionPrerfix);
    for(let p of permissions){
      this.setItem(this.userPermissionPrerfix+p,true);
    }
  }

  userHasPermission(permission:string){
    if(this.userPermissions.length>0){
      return this.userPermissions.includes(permission)
    }
    else{
      return this.getItem(this.userPermissionPrerfix+permission)
    }
  }

  removeItemsByPrefix(prefix:string){
    var arr:string[] = []; 
    for (var i = 0; i < this.storage.length; i++){
        const item=this.storage.key(i);
        if (item && item.startsWith(prefix)) {
            arr.push(item);
        }
    }
    for (var i = 0; i < arr.length; i++) {
        this.removeItem(arr[i]);
    }
  }

  setUserLanguage(items:any[]){
    for(let item of items){
      this.storage.setItem( `${this.userLanguagePrefix}${item.key}`, item.value)
    }
  }

  getUserLanguageWord(key:string){
    return this.storage.getItem( `${this.userLanguagePrefix}${key}`)
  }

  setUserCountry(val:string){
    this.setItem(this.userCountryKey,val)
  }

  getUserCountry(){
    return this.getItem(this.userCountryKey)
  }

  setUserServices(data:any){
    this.removeItemsByPrefix(this.userServicesPrefix);
    for (const [key, value] of Object.entries(data)) {
      if(data[key]){
        this.storage.setItem( `${this.userServicesPrefix}${key}`,'1');
      }
    }
  }

  userHasService(service:string):boolean{
    const item=this.storage.getItem( `${this.userServicesPrefix}${service}`);
    return (item)?true:false;
  }

}